// extracted by mini-css-extract-plugin
export var completionBody = "_kj-2";
export var completionCard = "_kj-0";
export var completionFooter = "_kj-3";
export var completionTitle = "_kj-1";